import { NavLink, Outlet, Routes, Route, Navigate } from 'react-router-dom';
import AdminBetsPage from './AdminBetsPage';
import AdminResultsPage from './AdminResultsPage';
import AdminSummary from './AdminSummary';
import LiveBanner from '../../components/LiveBanner';

function AdminLayout() {
  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-slate-800 text-white">
        <div className="max-w-6xl mx-auto px-4 py-3 flex justify-between items-center">
          <h1 className="font-bold">Admin — Bolão Copa 2026</h1>
          <nav className="flex gap-4 text-sm">
            <NavLink to="/admin" end className={({ isActive }) => (isActive ? 'underline' : '')}>
              Resumo
            </NavLink>
            <NavLink to="/admin/bets" className={({ isActive }) => (isActive ? 'underline' : '')}>
              Bolões
            </NavLink>
            <NavLink to="/admin/resultados" className={({ isActive }) => (isActive ? 'underline' : '')}>
              Resultados
            </NavLink>
            <NavLink to="/" className="underline">
              Voltar ao app
            </NavLink>
          </nav>
        </div>
      </header>
      <LiveBanner />
      <main className="max-w-6xl mx-auto px-4 py-6">
        <Outlet />
      </main>
    </div>
  );
}

export default function AdminPage() {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route index element={<AdminSummary />} />
        <Route path="bets" element={<AdminBetsPage />} />
        <Route path="resultados" element={<AdminResultsPage />} />
        <Route path="*" element={<Navigate to="/admin" />} />
      </Route>
    </Routes>
  );
}
